import styled from '@emotion/styled';
import { HrefText, H2, Text } from 'ds/components/typography';
import { HEADER_HEIGHT } from 'ds/components/Layout';
import { typographyFontSizeCfg } from 'ds/components/typography/types';

export const ShortlistPageWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    min-height: calc(100vh - ${HEADER_HEIGHT}px);
  `}
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
  display: flex;
  flex-direction: column;
`;

export const FooterWrapper = styled.div`
  ${({ theme }) => `
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    align-items: end;
    padding-bottom: ${theme.spacing(8)};
  `}

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    > div {
      flex-grow: 1;
    }
  `}
`;

export const LastContactSectionContainer = styled.div`
  padding: 24px 0;
  margin-bottom: 48px;
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
`;

export const LastContactEmptyState = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 16px;

  svg {
    min-width: 33px;
  }
`;

export const ShortlistPageEmptyStateText = styled(Text)`
  font-size: ${typographyFontSizeCfg.text}px;
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const ShortlistHeader = styled(H2)`
  ${({ theme }) => `
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const ShortListSectionWrapper = styled.div<{ isListCard?: boolean }>`
  ${({ theme }) => `
    padding-bottom: ${theme.spacing(7)};
  `}
  ${({ theme, isListCard }) => theme.media.showAt({ at: 1 })`
    padding-bottom: 0;
    padding-top: ${theme.spacing(4)};

    & > div {
      margin-${theme.isRTL ? 'right' : 'left'}: ${isListCard ? 0 : theme.spacing(2)};
    }
  `}
`;

export const ShowMore = styled(HrefText)<{ disableMargin?: boolean }>`
  display: inline-flex;
  font-size: 13px;
  align-items: center;
  cursor: pointer;
  ${({ disableMargin }) => disableMargin ? '' : 'margin: 0 8px;'}

  svg {
    fill: currentColor;
  }
`;

export const SmallCardPlaceholderMain = styled.div`
  height: 84px;
  display: flex;
  border: solid 1px ${({ theme }) => theme.colors.neutrals.grey7};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  position: relative;
  margin: 0 8px;

  &:after {
    content: '';
    height: 84px;
    width: 15px;
    position: absolute;
    top: 0;
    left: 0;
    background: ${props => props.theme.colors.neutrals.white};
    filter: blur(10px);
    animation: highlight-small 1.5s ease infinite;
    ${props => props.theme.isRTL ? `
      animation-direction: reverse;
    ` : ''}
  }

  @keyframes highlight-small {
    from {
      transform: translateX(0) rotate(${props => props.theme.isRTL ? '-' : ''}24deg);
    }
    to {
      transform: translateX(290px) rotate(${props => props.theme.isRTL ? '-' : ''}24deg);
    }
  }

  & > div:nth-of-type(1)  {
    flex-shrink: 0;
    background: ${props => props.theme.colors.neutrals.grey9};
    width: 84px;
  }
  & > div:nth-of-type(2)  {
    margin: 16px;
    width: 100%;
    & > div {
      margin-bottom: 4px;
      background: ${props => props.theme.colors.neutrals.grey9};
      border-radius: ${props => props.theme.borderRadius.tiny};
      height: 20px;
    }
    & > div:nth-of-type(1) {
      width: 90px;
    }
  }
  & + div {
    background: ${props => props.theme.colors.neutrals.grey8};
    border-radius: ${props => props.theme.borderRadius.tiny};
    margin: 12px 8px 0 8px;
    height: 38px;
    width: 75%;
    position: relative;
    overflow: hidden;

    &:after {
      content: '';
      height: 38px;
      width: 15px;
      position: absolute;
      top: 0;
      left: -34px;
      background: ${props => props.theme.colors.neutrals.white};
      filter: blur(10px);
      animation: highlight-small 1.5s ease infinite;
      ${props => props.theme.isRTL ? `
        animation-direction: reverse;
      ` : ''}
    }
  }
`;

export const EmptyStateWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    white-space: pre-line;
    margin-left: -${theme.spacing(2.5)};
    margin-right: -${theme.spacing(5)};
  `}
`;
